import { To, useHref, useLinkClickHandler } from "react-router-dom";

/**
 * Derives an `href` and click handler for a non-router anchor/button that should still navigate
 * client-side, reusing react-router's own click-interception logic (modifier keys, target=_blank, etc.)
 * instead of forcing a full page reload.
 */
export function useRouterLinkProps(to: To) {
  const href = useHref(to);
  const onClick = useLinkClickHandler(to);
  return { href, onClick };
}
